/** Which pen buttons switch to the eraser while held. Stored in settings. */
export interface ButtonMapping {
  /** Barrel/side button: PointerEvent buttons bit 2 (button === 2). */
  barrelErases: boolean;
  /** Eraser end or eraser button: buttons bit 32 (button === 5). */
  eraserBitErases: boolean;
  /** Any other non-primary bit (e.g. 4 = middle, 8/16 = back/forward). */
  otherErases: boolean;
}

export const DEFAULT_BUTTON_MAPPING: ButtonMapping = { barrelErases: true, eraserBitErases: true, otherErases: false };
export const BUTTON_MAPPING_KEY = 'penButtonMapping';

export function isEraserButtons(buttons: number, m: ButtonMapping): boolean {
  if (m.barrelErases && buttons & 2) return true;
  if (m.eraserBitErases && buttons & 32) return true;
  if (m.otherErases && buttons & (4 | 8 | 16)) return true;
  return false;
}
